










































































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import step3animationData from "@/assets/step3.json";
import step4animationData from "@/assets/step4.json";
import Lottie from "@/components/Lottie.vue";
import { MetaInfo } from "vue-meta";

@Component<Concept>({
  components: {
    Lottie,
  },
  metaInfo(): MetaInfo {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("appbar.concept"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("concept.description"),
        },
      ],
    };
  },
})
export default class Concept extends Vue {
  private step3AnimationOptions = {
    animationData: step3animationData,
    autoplay: true,
  };
  private step4AnimationOptions = {
    animationData: step4animationData,
    autoplay: true,
    speed: 0.3,
  };
}
